import styled from 'styled-components'

export const PageTitle = styled.div`
  font-family: 'Inter';
  font-size: 28px;
  font-style: normal;
  font-weight: 400;
  line-height: 40px;
  color: #202020;
  letter-spacing: 0;
  text-align: center;
  margin-bottom: 8px;
  margin-top: 184px;
`

export const PageSubtitleWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  flex-direction: row;
  margin-bottom: 96px;
`

export const PageSubtitle = styled.div`
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: 0; 
  color: rgba(32, 32, 32, 0.7);
`
export const StyleLabel = styled.div`
  font-family: 'Inter';
  font-style: normal;
  font-weight: 600;
  font-size: 20px;
  line-height: 32px;
  color: #202020; 
  padding-top: 64px;
  padding-bottom: 24px;
`
export const StyleSubText = styled.div`
  font-family: 'Inter';
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  color: #202020;
  text-align: justify;
`
export const StyleUl = styled.ul`
  padding-top: 32px;
  padding-bottom: 32px;
`

export const StyleLi = styled.li`
  font-family: 'Inter';
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  padding-left: 16px;
  padding-bottom: 16px;
  color: #202020;
`
export const StyleTableContents = styled.div`
  padding-top: 32px;
  padding-bottom: 16px;
`
export const StyleLabelContent = styled.div`
  font-family: 'Inter';
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  text-decoration-line: underline;
  padding-bottom:16px;
  color: #202020;
  cursor: pointer;
`
export const BottomNavigation = styled.ul`
  display: flex;
  align-items: center;
  list-style-type: none;
  margin: 0;
  padding: 0;
  margin-bottom: 32px;
`
export const NavigationLi = styled.li`
  font-family: 'Inter';
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  line-height: 16px;
  text-decoration-line: underline;
  a {
     color: #202020;
  }
`
export const StyleDot = styled.div`
  padding: 0 17px 0 17px;
`
